"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
const lit_html_1 = require("lit-html");
const loader_1 = require("./templates/loader");
/**
 * Лоадер
 */
class Loader {
    /**
     * Конструктор
     */
    constructor(selector, translations) {
        this.translations = translations;
        /**
         * Видимость
         */
        this.shown = false;
        this.selector = document.querySelector(selector) || undefined;
    }
    /**
     * Отображает лоадер
     */
    show() {
        this.shown = true;
        this.update();
    }
    /**
     * Скрывает лоадер
     */
    hide() {
        this.shown = false;
        this.update();
    }
    /**
     * Обновляет отображение
     */
    update() {
        if (this.selector) {
            (0, lit_html_1.render)((0, loader_1.getLoaderTemplate)(this.shown, this.translations), this.selector);
        }
    }
}
exports.Loader = Loader;
